export const FETCH_REFERRAL_COUPON_REQUEST = 'FETCH_REFERRAL_COUPON_REQUEST';
export const FETCH_REFERRAL_COUPON_SUCCESS = 'FETCH_REFERRAL_COUPON_SUCCESS';
export const FETCH_REFERRAL_COUPON_FAILURE = 'FETCH_REFERRAL_COUPON_FAILURE';

export const fetchReferralCouponRequest = id => ({
  type: FETCH_REFERRAL_COUPON_REQUEST,
  payload: { id }
});

export const fetchReferralCouponSuccess = response => ({
  type: FETCH_REFERRAL_COUPON_SUCCESS,
  payload: response
});

export const fetchReferralCouponFailure = err => ({
  type: FETCH_REFERRAL_COUPON_FAILURE,
  payload: err,
  error: true
});



// WEBPACK FOOTER //
// ./src/store/referralCoupon/actions.js